import React from 'react';
import { CATEGORY_OPTIONS, WEEKDAYS } from '../ProtocolDaysEditor';
import ProtocolExportActions from '../ProtocolExportActions';
import {
  DURATION_OPTIONS,
  WEIGHT_RANGE_OPTIONS,
  labelsFor,
  subcategoryLabels,
} from '../../../utils/protocol-form.util';
import { useProtocolCategories } from '../../../hooks/useProtocolCategories';
import styles from '../../../styles/mobileInfoPage.module.scss';

export default function ProtocolReviewStep({ formData, subcategoryOptions }) {
  const subcategoriesLabel = subcategoryLabels(formData.subcategories, subcategoryOptions);
  const durationLabel =
    DURATION_OPTIONS.find((d) => d.value === formData.durationDays)?.label || '-';
  const weightLabel = labelsFor(formData.weightRanges, WEIGHT_RANGE_OPTIONS);
  const categoryOptions = useProtocolCategories();
  const categoriesLabel = labelsFor(formData.categories, categoryOptions);
  const daysWithActivities = WEEKDAYS.map(({ key, label }) => ({
    label,
    activities: formData.days.find((d) => d.dayOfWeek === key)?.activities || [],
  })).filter((day) => day.activities.length > 0);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: 16,
        }}
      >
        <ProtocolExportActions
          protocol={formData}
          subcategoriesLabel={subcategoriesLabel}
          categoriesLabel={categoriesLabel}
        />
      </div>

      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Osnovni podaci</h3>
        {formData.imageUrl && (
          <img
            src={formData.imageUrl}
            alt="Protokol"
            style={{
              width: 160,
              height: 160,
              objectFit: 'cover',
              borderRadius: 8,
              marginBottom: 12,
            }}
          />
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, fontSize: 14 }}>
          <div>
            <strong>Kategorije:</strong> {categoriesLabel}
          </div>
          <div>
            <strong>Redosled:</strong> {formData.rank ?? '-'}
          </div>
          <div>
            <strong>Podkategorije:</strong> {subcategoriesLabel}
          </div>
          <div>
            <strong>Naziv:</strong> {formData.name.sr || '-'}
            {(formData.name.hu || formData.name.en) && (
              <span style={{ color: '#888' }}>
                {' '}
                (HU: {formData.name.hu || '-'} / EN: {formData.name.en || '-'})
              </span>
            )}
          </div>
          <div>
            <strong>Trajanje:</strong> {durationLabel}
          </div>
          <div>
            <strong>Opseg težine:</strong> {weightLabel}
          </div>
          {formData.versionNotes && (
            <div>
              <strong>Napomena o verziji:</strong> {formData.versionNotes}
            </div>
          )}
        </div>
      </section>

      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Dani i aktivnosti</h3>
        {daysWithActivities.length === 0 ? (
          <p style={{ color: '#888' }}>Nema definisanih aktivnosti.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {daysWithActivities.map((day) => (
              <div key={day.label}>
                <strong>{day.label}</strong>
                <ul style={{ margin: '4px 0 0', paddingLeft: 20 }}>
                  {day.activities.map((activity, index) => {
                    const categoryLabel =
                      CATEGORY_OPTIONS.find((c) => c.value === activity.category)?.label ||
                      activity.category;
                    return (
                      <li
                        key={index}
                        style={{
                          fontSize: 14,
                          marginBottom: 4,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                        }}
                      >
                        {activity.imageUrls?.[0] && (
                          <img
                            src={activity.imageUrls[0]}
                            alt=""
                            style={{
                              width: 24,
                              height: 24,
                              objectFit: 'cover',
                              borderRadius: 4,
                              flexShrink: 0,
                            }}
                          />
                        )}
                        <span>
                          {index + 1}. {activity.time || '-'} — {categoryLabel}: {activity.name?.sr || '-'}
                          {activity.dosage && ` (${activity.dosage})`}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
